module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_9005.b5077825.png";